<template>
  <div class="mt-4 p-2">
    <h3 class="section-title my-2">{{$t('tour_reservation_info')}}</h3>
    <dl class="grid grid-cols-5 gap-y-2">
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_reservation_number')}}</dt>
      <dd class="col-span-3">{{ reservation.reservationCode }}</dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_status')}}</dt>
      <dd class="col-span-3">{{ formatStatus }}</dd>
      <dt class="col-span-2 text-supplement font-semibold">
        {{$t('tour_reservation_pickuptime')}}
      </dt>
      <dd class="col-span-3">
        <span>{{ reservation.latestEstimatePickUpTime | datetimeFormat }}</span>
      </dd>
      <dt class="col-span-2 text-supplement font-semibold">
        {{$t('tour_reservation_dropofftime')}}
      </dt>
      <dd class="col-span-3">
        <span>{{ reservation.latestEstimateDropOffTime | datetimeFormat }}</span>
      </dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_departure_label')}}：</dt>
      <dd class="col-span-3" v-html=departure></dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_arrival_label')}}：</dt>
      <dd class="col-span-3" v-html=arrival></dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_passengers')}}</dt>
      <dd class="col-span-3">
        <reservation-amount :seatCountDetail="reservation.seatCountDetail" :totalOnly=true />
      </dd>
      <template v-if="reservation.fare.total && reservation.fare.table">
        <dt class="col-span-2 row-span-2 text-supplement font-semibold">{{$t('tour_fee')}}</dt>
        <dd class="col-span-3">{{ reservation.fare.total }}{{$t('tour_yen')}}
          <p v-if="isMaebashi()"
            class="inline-block mt-1 py-1 px-2 border rounded text-sm leading-none border-pass text-pass">
            {{$t('tour_maebashi_fare')}}
          </p>
          <br />
          <reservation-fares :fareTable="reservation.fare.table" /></dd>
      </template>
    </dl>
    <div class="text-center bg-gray-200 p-2 my-4">
      <p class="px-12">{{ message }}</p>
    </div>
    <reservation-contacts />
    <a @click="handleCancel" class="button-secondary block mb-2" :class="{ disabled: !isCancelable }">{{$t('tour_cancel_label')}}</a>
    <a @click="handleClose" class="button-secondary block">{{$t('tour_close_label')}}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ReservationAmount from '../../atoms/ReservationAmount'
import ReservationFares from '../../atoms/ReservationFares'
import ReservationContacts from "../../atoms/ReservationContacts"
import Constants from '../../../constants'

export default {
  components: {
    ReservationAmount,
    ReservationFares,
    ReservationContacts
  },
  created () {
    this.$store.dispatch('reservation/fetchPeriodically')
  },
  computed: {
    ...mapGetters({
      reservation: 'reservation/getReserved',
      type: 'reservation/getType',
      isCancelable: 'reservation/isCancelable'
    }),
    formatStatus: function () {
      let label
      switch(this.reservation.status){
        case "ASSIGINING":
          label = this.$t('tour_reserve_status_assigining')
          break
        case "ASSIGNED":
          label = this.$t('tour_reserve_status_assigned')
          break
        case "PICKING_UP":
          label = this.$t('tour_reserve_status_picking_up')
          break
        case "BOARDING":
          label = this.$t('tour_reserve_status_boarding')
          break
        case "FINISHED":
          label = this.$t('tour_reserve_status_finished')
          break
        case "CANCELED":
          label = this.$t('tour_reserve_status_canceled')
          break
        case "DENIED":
          label = this.$t('tour_reserve_status_denied')
          break
        case "declined":
          label = this.$t('tour_reserve_status_declined')
          break
        case "PENDING":
          label = this.$t('tour_reserve_status_pending')
          break
        default:
          break
      }
      return label
    },
    message: function () {
      let m
      const now = moment()
      const time = this.reservation.latestEstimatePickUpTime
      const diff = time.diff(now, 'minutes')

      if (diff > 1) {
        m = `${this.$t('tour_arrived_at')} ${diff} ${this.$t('tour_minute_label')}`
      } else {
        m = this.$t('tour_will_arrive')
      }
      return m
    },
    departure: function () {
      let s = this.reservation.pickUpBusstopName
      if (this.type == 'POSITION') {
        // const { lat, lng } = this.reservation.pickUpPosition
        s = this.reservation.pickUpLocationName // + '<br>' + lat + ', ' + lng
      }
      return s
    },
    arrival: function () {
      let s = this.reservation.dropOffBusstopName
      if (this.type == 'POSITION') {
       // const { lat, lng } = this.reservation.dropOffPosition
        s = this.reservation.dropOffLocationName // + '<br>' + lat + ', ' + lng
      }
      return s
    }
  },
  methods: {
    handleCancel: function () {
      this.$store.dispatch('reservation/cancel')
        .then(() => {
          const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
          location.href = Constants.LINK_BASE_URL_LIST[env_key] + '/?wallet=index'
        })
    },
    isMaebashi: function() {
      return this.$store.getters['user/isMaebashi']
    },
    handleClose: function () {
      const ticket = this.$store.getters['user/getTicket']
      const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      location.href = Constants.LINK_BASE_URL_LIST[env_key] + '/?wallet=onDemand&serialNumber=' + ticket.serialNumber
    }
  }
}
</script>

<style scoped>
.gap-y-2 {
  row-gap: 0.5rem;
}
</style>
